<template>
	<el-dialog :visible.sync="centerDialogVisible" width="420px" center class="login-dailog" :close-on-click-modal="false" :before-close="handleClose">
		<div class="dailog-box" style="padding-bottom: 30px;">
			<el-form ref="form" :model="form" :rules="rules" >
			  <el-form-item  prop="oldpwd" >
				<el-input type="password" v-model="form.oldpwd" placeholder="請輸入原始密碼" @keyup.native.enter="onSubmit">
				</el-input>
			  </el-form-item>
			  <el-form-item  prop="password">
				<el-input type="password" v-model="form.password" placeholder="輸入新密碼" @keyup.native.enter="onSubmit">
				</el-input>
			  </el-form-item>
			  <el-form-item  prop="cpassword">
				<el-input type="password" v-model="form.cpassword" placeholder="請確認新密碼" @keyup.native.enter="onSubmit">
				</el-input>
			  </el-form-item>

				<el-alert :title="errors.title" type="error" show-icon class="error" :closable="false" v-if="errors.show"></el-alert>

			  <el-form-item>
					<el-button type="primary" @click="onSubmit" style="width:100%">確認送出</el-button>
			  </el-form-item>

			</el-form>

		</div>
		<!-- <div class="dailog-footer">
			登錄時有任何問題，請聯繫我們24小時在線客服協助解決，本網站採用Global Trust最先進的128/256 bit SSL服務器加密機制
		</div> -->

	</el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data() {
		const validateUsername = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('請輸入會員帳號'));
			} else {
				this.form.disable = false;
				callback();
			}
		};
		const validatePassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('請輸入密碼'));
			} else {

				callback();
			}
		};

		return {
			errors:{
				show : false,
				title : '密碼錯誤'
			},
			//activeIndex: this.$router.currentRoute.path,
			centerDialogVisible: false,
			form: {
				oldpwd: '',
				password: '',
                cpassword: '',
			},
			rules: {
				oldpwd: [{
					validator: validatePassword,
					trigger: 'blur'
				}],
				password: [{
					validator: validatePassword,
					trigger: 'blur'
				}],
				cpassword: [{
					validator: validatePassword,
					trigger: 'blur'
				}],                
			},
		};
	},
	methods: {
		forgotpwd()
		{
			// return this.$layer.msg('請聯絡客服人員');
			window.open(this.config.CustomerServiceUrl,'', 'height=500,width=500,location=no,menubar=no,menubar=no');
		},
		handleClose(done){
			// if (/^\/user/.test(this.$router.currentRoute.path)){
			// 	this.$router.replace('/');
			// }
			done();
		},
        go2page(page){
			this.centerDialogVisible = false;
            let cmd = page;
            this.$router.push('/' + cmd);
        },
		pwd() {
			this.centerDialogVisible = true;
		},
		onSubmit() {
            this.$axios({
                method : 'POST',
                url : this.config.ApiUrl + '/api/change-pwd' ,
                data: {
                    'curPassword' : this.form.oldpwd,
                    'newPassword' : this.form.password,
                    'newPassword_confirmation' : this.form.cpassword
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                //console.log(response.data);
                this.$layer.msg(response.data.message);
                if (response.data.status){
                    this.centerDialogVisible = false;
                    this.form.oldpwd = '';
                    this.form.password = '';
                    this.form.cpassword = '';
                    // this.active++;
                    // this.$router.go(-1);
                    /*
                    setTimeout(() => {
                            this.logout();
                        }, 2000);*/
                }
                this.form.loading = false;

            }).catch(error => {
                console.log(error);
                this.form.loading = false;
            });

		}
	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
		}),
    },
	created() {

		//console.log(this.$bet.alert('ddd'));
		//console.log('my',this.user);
		
		//this.$store.dispatch('actionAJAXexample');
	}
}
</script>
<style>
.login-dailog .el-dialog__body {padding:10px;}
.login-dailog .dailog-footer {

	padding:12px 18px;
	font-size:14px;
	    color: #837c7c;
    line-height: 18px;

	letter-spacing: 1px;

    background: #3a3a3a;
	background-size: contain;
    color: #EEE;
}
.dailog-logo {
}
.dailog-box {padding:0 45px;}
.dailog-box .txt{font-size:18px;text-align:center;padding:10px 0 20px 0;color: #fff}
.dailog-logo {
    display: block;
    width: 109px;
    height: 83px;

    margin: 0 auto 6px;
}
.dailog-box .error {
	margin-bottom:15px;
}

.forget-pwd{
    float: right;
}
.login-dailog .el-dialog{
	background: var(--bg-dailog-color) !important;
	/* background: #111; */
}
.login-dailog .el-form-item__content{
	color: var(--secondary-font-color);
	/* color: #fff; */
}
.login-dailog .el-button--text{
	color: var(--accent-color);
	/* color: #fff; */
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordBox.vue